<template>
    <ul class="list-group mb-3" v-if="pacotes && pacotes.length">
        <li class="list-group-item d-flex justify-content-between" v-for="(pacote, idx) in pacotes" :key="idx">
            <div>
                <i class="fas fa-layer-group mr-2 text-primary"></i>
                <small v-if="1 == 0" class="text-muted mr-2">
                    {{ total_sessoes(pacote) }} SESSÕES
                </small>
                <span class="text-dark mr-2">
                    <span v-if="pacote.procedimento">
                        {{ pacote.procedimento.search }}
                    </span>
                    <span v-else>
                        {{ pacote.procedimento_pacote.procedimento.search }}
                    </span>

                    <span v-if="pacote.pacote && pacote.pacote.procedimento && pacote.pacote.fl_combo" 
                        class="text-muted small ml-3">
                        {{ pacote.pacote.procedimento.st_procedimento }}
                    </span>

                    <template v-if="link">
                        <a href="#" @click.prevent="selecionar(pacote)" class="card-link">
                            <span v-if="pacote.st_regiao" class="ml-2 badge badge-primary">
                                {{ pacote.st_regiao }}
                            </span>        
                        </a>
                    </template>

                    <template v-else>
                        <span v-if="pacote.st_regiao" class="ml-2 badge badge-secondary">
                            {{ pacote.st_regiao }}
                        </span>
                    </template>

                    <template v-if="pacote.pacote.fl_por_unidade && pacote.unidade_operacao && pacote.unidade_operacao.st_sigla">
                        <span class="ml-2 badge badge-light" :title="pacote.unidade_operacao.st_nome">
                            {{ pacote.unidade_operacao.st_sigla }}
                        </span>
                    </template>
                </span>
                <div class="mb-0">
                    <span v-if="pacote.atendimento && pacote.atendimento.plano" class="small text-muted">
                        {{ pacote.atendimento.plano.search }}
                    </span>
                </div>
            </div>
            <div class="text-right" style="min-width: 50px;">
                <span class="mr-1" v-if="pacote.in_sessoes_previas" title="Sessões prévias realizadas em outro local.">{{ pacote.in_sessoes_previas }} +</span>
                <span class="text-primary">{{ pacote.atendimento_procedimentos_count }}</span>
                <span>/{{ total_sessoes(pacote) }}</span>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: ['pacotes', 'link'],

    methods: { 

        selecionar (pacote) { 
            this.$emit('selecionar', pacote);
        },

        total_sessoes (pacote) { 
            return pacote.in_quantidade_items ? pacote.in_quantidade_items : pacote.procedimento_pacote.in_quantidade;
        }

    }
}
</script>